var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H22C22.4142 3.25 22.75 3.58579 22.75 4V22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22V4ZM2.75 4.75V21.25H21.25V4.75H2.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.25C6.41421 1.25 6.75 1.58579 6.75 2V5.5C6.75 5.91421 6.41421 6.25 6 6.25C5.58579 6.25 5.25 5.91421 5.25 5.5V2C5.25 1.58579 5.58579 1.25 6 1.25Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1.25C18.4142 1.25 18.75 1.58579 18.75 2V5.5C18.75 5.91421 18.4142 6.25 18 6.25C17.5858 6.25 17.25 5.91421 17.25 5.5V2C17.25 1.58579 17.5858 1.25 18 1.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 8C1.25 7.58579 1.58579 7.25 2 7.25H6C6.41421 7.25 6.75 7.58579 6.75 8C6.75 8.41421 6.41421 8.75 6 8.75H2C1.58579 8.75 1.25 8.41421 1.25 8ZM9.25 8C9.25 7.58579 9.58579 7.25 10 7.25H22C22.4142 7.25 22.75 7.58579 22.75 8C22.75 8.41421 22.4142 8.75 22 8.75H10C9.58579 8.75 9.25 8.41421 9.25 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a6c7ade8af67fb229fb184e35d04b03f.svg";
export { ForwardRef as ReactComponent };